import { AppRoute } from '../enums/appRoutes';
import { StepKey } from '../enums/stepKey';
import { ApplianceDetailsPage } from '../pages/ApplianceDetailsPage/ApplianceDetailsPage';
import { ArrivalDatePage } from '../pages/ArrivalDatePage';
import { PersonalDetailsPage } from '../pages/PersonalDetails/PersonalDetailsPage';
import { PricePage } from '../pages/PricePage';
import { ModelSerialLanding } from '../pages/Landing/ModelSerialLanding/ModelSerialLanding';

export const getTestRoutes = (
  landingHeroPath: string,
  landingBrandPath: string,
  environment?: string,
) => [
  {
    path: AppRoute.LANDING,
    element: (
      <ModelSerialLanding
        heroBackground={landingHeroPath}
        brandImage={landingBrandPath}
        environment={environment}
      />
    ),
    stepKey: StepKey.MODEL_SERIAL,
    title: 'Model Serial',
  },
  {
    path: AppRoute.APPLIANCE_DETAILS,
    element: <ApplianceDetailsPage totalSteps={5} stepNumber={1} />,
    stepKey: StepKey.APPLIANCE_DETAILS,
    title: 'Appliance Details',
  },
  {
    path: AppRoute.PURCHASE_PRICE,
    element: <PricePage totalSteps={5} stepNumber={3} />,
    stepKey: StepKey.PURCHASE_PRICE,
    title: 'Purchase Price',
  },
  {
    path: AppRoute.ARRIVAL_DATE,
    element: <ArrivalDatePage totalSteps={5} stepNumber={4} />,
    stepKey: StepKey.ARRIVAL_DATE,
    title: 'Arrival Date',
  },
  {
    path: AppRoute.PERSONAL_DETAILS,
    element: <PersonalDetailsPage totalSteps={5} stepNumber={5} />,
    stepKey: StepKey.PERSONAL_DETAILS,
    title: 'Personal Details',
  },
];
